import { render, staticRenderFns } from "./changeCom.vue?vue&type=template&id=f715bac4&scoped=true&"
import script from "./changeCom.vue?vue&type=script&lang=js&"
export * from "./changeCom.vue?vue&type=script&lang=js&"
import style0 from "./changeCom.vue?vue&type=style&index=0&id=f715bac4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f715bac4",
  null
  
)

export default component.exports